
<div class="col-md-8">
    <div class="row">
        <div class="col-md-12">
            <div class="post-138 page type-page status-publish hentry">
                <div class="widget-main">
                    <div class="widget-inner">
                        <h3 class="archive-title">Passwort ändern</h3>

                        <form [formGroup]="formular" (ngSubmit)="aenderePasswort()" role="form"
                              class="form-horizontal register-form">

                            <div class="form-group">
                                @if (! resetToken) {
                                <label class="col-sm-2 control-label">Altes Passwort</label>
                                <div class="col-sm-8">
                                    <input pInputText id="altesPwInput" formControlName="altesPasswort" class="ms-form-text" type="password"
                                           value=""
                                           required="">
                                </div>
                                }
                            </div><div class="form-group">
                                <label class="col-sm-2 control-label">Neues Passwort</label>
                                <div class="col-sm-8">
                                    <input pInputText formControlName="neuesPasswort" class="ms-form-text" type="password"
                                           value=""
                                           required="">
                                </div>
                            </div><div class="form-group">
                                <label class="col-sm-2 control-label">Neues Passwort bestätigen</label>
                                <div class="col-sm-8">
                                    <input pInputText formControlName="neuesPwBestaetigen" class="ms-form-text" type="password"
                                           value=""
                                           required="">
                                </div>
                            </div>

                            <div class="form-group">
                                <div>
                                    <input [disabled]="!formular.valid" class="btn btn-primary" type="submit"
                                           value="Speichern">
                                </div>
                            </div>

                        </form>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
